import { TranslationFunction } from 'i18next'
import React, { SFC } from 'react'
import { NavLink, RouteComponentProps } from 'react-router-dom'

import { i18nKeys } from '../app.i18n'
import { links } from '../app.links'
import { User } from '../auth'
import { ACTIVE_CLASS_NAME, NAVLINK_CLASS_NAME } from '../shared'

type Props = RouteComponentProps<{}> & {
  t: TranslationFunction
  user: User
}

export const AdminNav: SFC<Props> = ({ t, user }) => (
  <>
    <div className="sidebar__title">{t(i18nKeys.frontFace.activityBar.admin)}</div>
    {user.accessRoles.canViewPerson && (
      <NavLink className={NAVLINK_CLASS_NAME} activeClassName={ACTIVE_CLASS_NAME} to={links.admin.persons.home()}>
        {t(i18nKeys.admin.activityBar.persons)}
      </NavLink>
    )}
    {user.accessRoles.canViewOrganizationUnit && (
      <NavLink className={NAVLINK_CLASS_NAME} activeClassName={ACTIVE_CLASS_NAME} to={links.admin.organizations.home()}>
        {t(i18nKeys.admin.activityBar.organizations)}
      </NavLink>
    )}
    {user.accessRoles.canViewBlogPost && (
      <NavLink className={NAVLINK_CLASS_NAME} activeClassName={ACTIVE_CLASS_NAME} to={links.admin.blogs.home()}>
        {t(i18nKeys.admin.activityBar.blogs)}
      </NavLink>
    )}

    {user.accessRoles.canViewImports && (
      <NavLink className={NAVLINK_CLASS_NAME} activeClassName={ACTIVE_CLASS_NAME} to={links.admin.import.home()}>
        {t(i18nKeys.admin.activityBar.import)}
      </NavLink>
    )}

    {user.accessRoles.canViewBonusPeriod && (
      <NavLink className={NAVLINK_CLASS_NAME} activeClassName={ACTIVE_CLASS_NAME} to={links.admin.bonusPeriods.home()}>
        {t(i18nKeys.admin.activityBar.bonusPeriod)}
      </NavLink>
    )}

    {user.accessRoles.canViewImports && (
      <NavLink className={NAVLINK_CLASS_NAME} activeClassName={ACTIVE_CLASS_NAME} to={links.admin.mergeProfiles.home()}>
        {t(i18nKeys.admin.activityBar.mergeProfiles)}
      </NavLink>
    )}
    {user.accessRoles.canUseAdministrationSection && (
      <NavLink className={NAVLINK_CLASS_NAME} activeClassName={ACTIVE_CLASS_NAME} to={links.admin.adminActions.home()}>
        {t(i18nKeys.admin.activityBar.adminActions)}
      </NavLink>
    )}
  </>
)



// WEBPACK FOOTER //
// ./src/app/sidebar-navigation/admin.tsx